import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "vp-sidebar-children" }

import VPAutoLink from '@theme/VPAutoLink.vue'
import VPDropdownTransition from '@theme/VPDropdownTransition.vue'
import { isActiveSidebarItem } from '@theme/isActiveSidebarItem'
import { useToggle } from '@vueuse/core'
import { computed, nextTick, onBeforeUnmount, toRefs } from 'vue'
import { useRoute, useRouter } from 'vuepress/client'
import type { SidebarItem } from '../typings.js'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPSidebarItem',
  props: {
    item: {},
    depth: { default: 0 }
  },
  setup(__props: any) {

const props = __props

const { item, depth } = toRefs(props)
const route = useRoute()
const router = useRouter()

const collapsible = computed(
  () => 'collapsible' in item.value && item.value.collapsible,
)
const isActive = computed(() => isActiveSidebarItem(item.value, route))
const itemClass = computed(() => ({
  'vp-sidebar-item': true,
  'vp-sidebar-heading': depth.value === 0,
  'active': isActive.value,
  'collapsible': collapsible.value,
}))

const isOpenDefault = computed(() =>
  collapsible.value ? isActive.value : true,
)
// eslint-disable-next-line vue/no-ref-object-reactivity-loss
const [isOpen, toggleIsOpen] = useToggle(isOpenDefault.value)
const onClick = (e: Event): void => {
  if (collapsible.value) {
    e.preventDefault()
    // toggle open status on click
    toggleIsOpen()
  }
}

// reset open status after navigation
const unregisterRouterHook = router.afterEach(() => {
  void nextTick(() => {
    isOpen.value = isOpenDefault.value
  })
})
onBeforeUnmount(() => {
  unregisterRouterHook()
})

return (_ctx: any,_cache: any) => {
  const _component_VPSidebarItem = _resolveComponent("VPSidebarItem", true)!

  return (_openBlock(), _createElementBlock("li", null, [
    (_unref(item).link)
      ? (_openBlock(), _createBlock(VPAutoLink, {
          key: 0,
          class: _normalizeClass(itemClass.value),
          config: _unref(item)
        }, null, 8, ["class", "config"]))
      : (_openBlock(), _createElementBlock("p", {
          key: 1,
          tabindex: "0",
          class: _normalizeClass(itemClass.value),
          onClick: onClick,
          onKeydown: _withKeys(onClick, ["enter"])
        }, [
          _createTextVNode(_toDisplayString(_unref(item).text) + " ", 1),
          (collapsible.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["arrow", _unref(isOpen) ? 'down' : 'right'])
              }, null, 2))
            : _createCommentVNode("", true)
        ], 34)),
    ('children' in _unref(item) && _unref(item).children.length)
      ? (_openBlock(), _createBlock(VPDropdownTransition, { key: 2 }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("ul", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(item).children, (child) => {
                return (_openBlock(), _createBlock(_component_VPSidebarItem, {
                  key: `${_unref(depth)}${child.text}${child.link}`,
                  item: child,
                  depth: _unref(depth) + 1
                }, null, 8, ["item", "depth"]))
              }), 128))
            ], 512), [
              [_vShow, _unref(isOpen)]
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})